
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[appName]/forgot-password",
      function () {
        return require("private-next-pages/[appName]/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[appName]/forgot-password"])
      });
    }
  